'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../components/Placeholder');

var _transitions = require('./transitions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(_transitions.Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? _transitions.collapseDuration : 1
    }, props));
  };
};

exports.default = AnimatedPlaceholder;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-select/lib/animated/Placeholder.js
 ** module id = 1045
 ** module chunks = 0
 **/